import angular from 'angular';

import SelectedDateRangeComponent from './selected-date-range.cmpt';

export default angular
    .module('application.scene.authorized.scene.dashboard.component.selected-date-range', [])
    .component(SelectedDateRangeComponent.selector, SelectedDateRangeComponent);



// WEBPACK FOOTER //
// ./src/application/scene/authorized/scene/dashboard/component/selected-date-range/index.js